import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { X } from '@phosphor-icons/react';
import Button from '../button/button';
import Icon from '../icon/icon';
import './style.scss';

const Modal = (props) => {
  const {
    primaryText,
    secondaryText,
    onClickPrimaryCta,
    onClickSecondaryCta,
    children,
    customFooter,
    className,
    size,
    isOpen,
    title,
    hasClose,
    onClose,
    customHeader,
    headerClassName,
    footerClassName,
    ...attr
  } = props;

  const { activeRequests } = useSelector((state) => state.app);
  console.log('active requests', activeRequests);
  const [ loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeRequests?.includes('save-event') || activeRequests?.includes('delete') || activeRequests?.includes('save-business-config') || activeRequests?.includes('initiate-refund')) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [activeRequests]);

  return (
    isOpen && (
      <div
        className={`modal fixed size-full flex items-center justify-center ${className}`}
        {...attr}
      >
        <div className={`modal-container relative flex flex-col shadow-lg ${size}`}>
          <div className={`modal-header heading-24 text-black flex ${headerClassName} items-center${hasClose ? ' justify-between' : ''} size`}>
            {title}
            {hasClose && (
              <Icon
                className="cursor-pointer"
                type="circle"
                onClick={onClose}
              >
                <X
                  color="#101010"
                  size={16}
                />
              </Icon>)}
          </div>
          <div className="modal-content flex-1">
            {children}
          </div>
          {customFooter || (!![onClickPrimaryCta, onClickSecondaryCta].filter((func) => !!func).length && (
            <div className={`modal-footer flex ${footerClassName}`}>
              <Button
                className="secondary-cta"
                type="tertiary"
                onClick={onClickSecondaryCta}
              >
                {secondaryText}
              </Button>
              <Button
                className="primary-cta"
                type="primary-black"
                onClick={onClickPrimaryCta}
                loading={loading}
              >
                {primaryText}
              </Button>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

Modal.propTypes = {
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  onClickPrimaryCta: PropTypes.func,
  onClickSecondaryCta: PropTypes.func,
  children: PropTypes.node,
  customFooter: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['regular', 'medium', 'large']),
  isOpen: PropTypes.bool,
  title: PropTypes.node,
  hasClose: PropTypes.bool,
  onClose: PropTypes.func,
  customHeader: PropTypes.node,
  footerClassName: PropTypes.string,
  headerClassName: PropTypes.string
};

Modal.defaultProps = {
  primaryText: 'Save',
  secondaryText: 'Cancel',
  onClickPrimaryCta: null,
  onClickSecondaryCta: null,
  children: null,
  customFooter: null,
  className: '',
  size: 'medium',
  isOpen: true,
  title: null,
  hasClose: false,
  onClose: () => null,
  customHeader: null,
  footerClassName: '',
  headerClassName: ''
};

export default Modal;
